export default __webpack_public_path__ + "static/media/linkedin.be51f3b4.svg";